/*
 * The footer copyright used to carry a hardcoded year, which meant it silently
 * went stale every January. These helpers derive it from the clock instead.
 */

export const SITE_LAUNCH_YEAR = 2024;

/*
 * Returns the copyright year span for the footer.
 *
 * While it is still the launch year this is a single year ("2024"); after that
 * it becomes a range ("2024-2026"). `now` is injectable so tests do not depend
 * on the current date.
 */
export function getCopyrightYears(
  launchYear = SITE_LAUNCH_YEAR,
  now = new Date()
) {
  const currentYear = now.getFullYear();

  if (!Number.isFinite(currentYear) || currentYear <= launchYear) {
    return String(launchYear);
  }

  return `${launchYear}–${currentYear}`;
}

/*
 * Full notice as rendered, e.g. "Compass Through The Bible (c) 2024-2026".
 */
export function getCopyrightNotice(
  siteName = "Compass Through The Bible",
  launchYear = SITE_LAUNCH_YEAR,
  now = new Date()
) {
  return `${siteName} © ${getCopyrightYears(launchYear, now)}`;
}
